import React from 'react';

import { Check, Lock } from 'lucide-react';

import { JourneyWorldIcon } from './JourneyWorldIcon';

import { IMcsaWorld, TMcsaWorldStatus } from '../../../../types/mcsa.interface';
import { playMcsaSfx } from '../../../../helpers/mcsa-sfx.helper';

interface JourneyMapNodeProps {
    world: IMcsaWorld;
    status: TMcsaWorldStatus;
    onSelect: (world: IMcsaWorld) => void;
}

export const JourneyMapNode = (props: JourneyMapNodeProps) => {
    const { world, status, onSelect } = props;

    return (
        <button
            type='button'
            className={`mcsa_journey_map__node mcsa_journey_map__node--${world.key} mcsa_journey_map__node--${status}`}
            aria-disabled={status === 'locked'}
            onClick={() => {
                if (status === 'locked') {
                    playMcsaSfx('buzz');
                    return;
                }
                onSelect(world);
            }}
        >
            <div className='mcsa_journey_map__node__badge'>
                {status === 'current' && <span className='mcsa_journey_map__node__pulse' />}
                <span className='mcsa_journey_map__node__icon'>
                    <JourneyWorldIcon worldKey={world.key} />
                </span>
                {status === 'locked' && (
                    <span className='mcsa_journey_map__node__status mcsa_journey_map__node__status--locked'>
                        <Lock />
                    </span>
                )}
                {status === 'done' && (
                    <span className='mcsa_journey_map__node__status mcsa_journey_map__node__status--done'>
                        <Check />
                    </span>
                )}
            </div>
            <span className='mcsa_journey_map__node__label'>{world.map_label}</span>
        </button>
    );
};
